const practitionerPicker = {
  practitionerPickerTitle: "Choose a practitioner to write on behalf of.",
};

export { practitionerPicker };
